module.exports = __webpack_public_path__ + "img/Spectrum-pattern-edit.6235eee3.jpg";